import type { PipelineActivityTemplate } from '@/services/api/cases'
import { cn } from '@/utils/cn'
import { PipelineActivityCard } from './PipelineActivityCard'
import { type PipelineStage, STAGE_TONE } from './pipeline-stage'

export function PipelineActivitySection({
  title,
  stage,
  activities,
}: {
  title: string
  stage: PipelineStage
  activities: PipelineActivityTemplate[]
}) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <div className={cn('w-3 h-3 rounded-full', STAGE_TONE[stage].dot)} />
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        <span className="text-sm text-muted-foreground">({activities.length})</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {activities.map(a => (
          <PipelineActivityCard key={a.id} activity={a} stage={stage} />
        ))}
      </div>
    </div>
  )
}
